import axios from "axios";

export default axios.create({
    baseURL: "https://backend.softecnu.org/api",
   //  baseURL: "http://127.0.0.1:8000/api",
});
